import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import { Formik } from 'formik';
import Drawer from 'components/Drawer';
import AccumulationDetails from '../AccumulationDetails';
import NDCAccumulationDetails from '../AccumulationsN';
import { faL } from '@fortawesome/free-solid-svg-icons';
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import { Button } from 'reactstrap';
import HoverImage from 'react-hover-image/build';
import ViewHover from "assets/icon/icon-icon-options-view-patient_hover.svg"
import view from "assets/icon/icon-icon-options-view-patient.svg"

const InventoryTable = ({
    data,
    orgId,
    onExport,
    tenantID,
    filters,
    loading,
    totalSize,
    onPageChange,
    collapseSider,
  toggleSider,
    onSearchColumnFilters = () => '',
    refetch,
    resetFilterFlag,
SetResetFilterFlag
}) => {

    //const [tableData, setTableData] = useState(tableDataBackup);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenlastPurchaseDate, setIsOpenlastPurchaseDate] = useState(false);
    const [drawer, setDrawer] = useState('');
    const [drawerlastPurchaseDate, setDrawerlastPurchaseDate] = useState('');
    const [accRowData, setAccRowData] = useState({});
    const [drugName, setdrugName] = useState({});
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);
    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {renderNdcButton(rowData)}
                
            </div>
        );
    };

  useEffect(()=>{
        setIsOpen(false)
        setIsOpenlastPurchaseDate(false)
    },[orgId])

    const renderNdcButton = (rowData) => {
           return <Button
               className='text-primary p-0 text-decoration-none'
               color='link'
               onClick={() => handleNdc(rowData)}
               title='NDC'

           >
               <HoverImage src={view}
                   hoverSrc={ViewHover}
                   alt='' />
           </Button>
   }
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            width: 100,
            show: true,
            disabled: true,
            hideColFilter: false,
            action: true,
            cellRenderer: (rowData) => cellRenderEdit(rowData),
        },
        {
            dataField: 'wholeSalerDrugCode',
            text: 'Item #',
            sort: true,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.wholeSalerDrugCode),
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            sort: true,
            width: 130,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.ndc),
        },
        {
            dataField: 'drugName',
            text: 'Drug Name',
            sort: true,
            width: 260,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.drugName),
        },
        {
            dataField: 'packageSize',
            text: 'Package Size',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => row.packageSize == 0 ? 0 : cellRendererCheck(row.packageSize),
        },
        {
            dataField: 'brandOrGeneric',
            text: 'Brand or Generic',
            sort: true,
            width: 165,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.brandOrGeneric),
        },
        {
            dataField: 'controlledSubstance',
            text: 'Controlled Substance',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.controlledSubstance),
        },
        {
            dataField: 'accumulations340B',
            text: '340B Accumulations',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => row.accumulations340B == 0 ? 0 : cellRendererCheck(row.accumulations340B),

        },
        {
            dataField: 'price340B',
            text: '340B Price ',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.price340B),
        },
        {
            dataField: 'accumulationsGPO',
            text: 'GPO Accumulations',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => row.accumulationsGPO == 0 ? 0 : cellRendererCheck(row.accumulationsGPO),
        },
        {
            dataField: 'priceGPO',
            text: 'GPO Price ',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.priceGPO),
        },
        {
            dataField: 'accumulationsWAC',
            text: 'WAC Accumulations',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => row.accumulationsWAC == 0 ? 0 : cellRendererCheck(row.accumulationsWAC),
        },
        {
            dataField: 'priceWAC',
            text: 'WAC Price ',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.priceWAC),
        },
        {
            dataField: 'savings340BperPack',
            text: '340B Savings/Pack ',
            sort: true,
            width: 140,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.savings340BperPack),
        },
        {
            dataField: 'estTotal340BSavings',
            text: 'Est. Total 340B Savings ',
            sort: true,
            width: 150,
            show: true,
            inputType: 'number',
            hideColFilter: false,
            cellRenderer: (row) => currencyFormat(row.estTotal340BSavings),
        },
        {
            dataField: 'lastAccumDate',
            text: 'Last Accumulation Date',
            sort: true,
            width: 175,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (row) => dateFormate(row.lastAccumDate),
        },
        {
            dataField: 'lastOrderDate',
            text: 'Last Purchase Date',
            sort: false,
            width: 150,
            show: true,
            inputType: 'date',
            hideColFilter: false,
            cellRenderer: (row) => cellRenderGcnDetails(row),
        },
        {
            dataField: 'hiddenNDCFlag',
            text: 'Hidden NDC',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hiddenNDCFlag)
        },
    ];
    const cellRenderLink = (row) => {
        // if (hasPermission('VWPO')) {
        const { ndc } = row;
        if (ndc) {
            return (
                <span
                    className='text-decoration-underline d-inline-block cursor-pointer'
                    onClick={() => handleNdc(row)}
                >
                    {ndc}
                </span>
            );
        }
        return '-';
    };

    const handleNdc = (row) => {
        setIsOpen(!isOpen);
        setDrawer('ndc');
        setAccRowData(row);
    };
    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSearchColumnFilters = (colFilter) => {
        debugger;
        for(var x in colFilter){
            if(colFilter[x].filterName == 'priceGPO' || colFilter[x].filterName == 'estTotal340BSavings' || colFilter[x].filterName == 'price340B' || colFilter[x].filterName == 'savings340BperPack'){
              colFilter[x].filterValue = (colFilter[x].filterValue).replace(/,/g, "")
            }
          }
        if (onSearchColumnFilters) {
            onSearchColumnFilters(colFilter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const handleFilterCancel = () => {
        refetch();
    };


    const toggleDrawer = () => {
        setIsOpen(!isOpen);
        setDrawer('');
    };

    const drawerClose = (hasUpdated) => {
        setIsOpen(!isOpen);
        setDrawer('');
        if (hasUpdated) refetch();
    };

    const cellRenderGcnDetails = (row) => {
        // if (hasPermission('VWPO')) {
        const { lastOrderDate } = row;
        if (lastOrderDate) {
            return (

                <span
                    className='text-decoration-underline d-inline-block cursor-pointer'
                    onClick={() => handlelastPurchaseDate(row)}
                >
                    {dateFormate(lastOrderDate)}
                </span>
            );
        }
        return '-';
        // }
    };

    const handlelastPurchaseDate = (row) => {
        setIsOpenlastPurchaseDate(!isOpenlastPurchaseDate);
        setDrawerlastPurchaseDate('lastPurchaseDate');
        setAccRowData(row);
    };

    const togglelastPurchaseDateDrawer = () => {
        setIsOpenlastPurchaseDate(!isOpenlastPurchaseDate);
        setDrawerlastPurchaseDate('');
    };

    const drawerlastPurchaseDateClose = (hasUpdated) => {
        setIsOpenlastPurchaseDate(!isOpenlastPurchaseDate);
        setDrawerlastPurchaseDate('');
        if (hasUpdated) refetch();
    };

    const { filters: colFilter, backUpData } = state;

    return (
        <div>
               <h5 className="f-16 text-primary font-weight-700">
        Accumulations Count ({totalSize})
            </h5>
            <hr/>
            <div
        //     className='table-card scroll-table position-relative border-0 rounded pt-0'
        // // fixed-height={data.length > 0 ? "fixed-height" : "default"}
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
            backUpData.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
        
        >
            <ReactStrapTable
                id='inventory-table'
                fixedColumn
                data={backUpData}
                loading={loading}
                columns={mainCol}
                onPageSizeChange={onPageSizeChange}
                pageSize={filters.pageSize}
                onExport={onExport}
                hasPagination = {backUpData?.length>0 ?true : false}
                onPageChange={onHandlePageChange}
                currentPage={filters.currentPage}
                totalRecords={totalSize}
                handleSort={handleSort}
                filters={filters}
                onSearchColumnFilters={handleSearchColumnFilters}
                onFilterCancel={handleFilterCancel}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                showtoggle={true}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
            />

            <Drawer
                direction="end"
                title="Accumulation Details"
                isOpen={isOpen}
                toggle={toggleDrawer}
                size="lg"
            >
                <AccumulationDetails rowData={accRowData} tenantID={tenantID} onClose={drawerClose}  />
            </Drawer>
            <Drawer
                direction="end"
                title="NDC Historical Purchase Details"
                isOpen={isOpenlastPurchaseDate}
                toggle={togglelastPurchaseDateDrawer}
                size="lg"
            >
                <NDCAccumulationDetails tenantID={tenantID} rowData={accRowData} onClose={drawerlastPurchaseDateClose} />
            </Drawer>

        </div>
        </div>
       
    );
};

export default InventoryTable
